module.exports = __webpack_public_path__ + "static/img/solution-2.32da44fb.png";